

export const formateDate = (date: string | Date) => {
  const inputDate = new Date(date)
  const year = inputDate.getFullYear()
  const month = String(inputDate.getMonth() + 1).padStart(2, "0")
  const day = String(inputDate.getDate()).padStart(2, "0")
  return `${year}-${month}-${day}`
}

export const tooltipFormat = (date: Date | undefined): string => {
  // Convert string to Date if necessary
  const dateObj = typeof date === 'string' ? new Date(date) : date;

  // Get month and day of the month
  const options: Intl.DateTimeFormatOptions = {
    month: 'short', // Use 'short' for abbreviated month name
    day: '2-digit', // Get day of the month as two digits
  };

  const formattedDate = dateObj?.toLocaleString('en-US', options);

  // Clean up the result to format it as "Apr 07"
  const result = formattedDate?.replace(/,/g, '').trim(); // Remove comma

  return result ?? ""; // Return the formatted date
};

export const extractTime = (dateStr: string | Date): string => {
  const date = new Date(dateStr);
  
  // Check if the date is valid
  if (isNaN(date.getTime())) {
    throw new Error("Invalid date");
  }

  const hours = String(date.getHours()).padStart(2, '0'); // Pad with leading zero
  const minutes = String(date.getMinutes()).padStart(2, '0'); // Pad with leading zero
  
  return `${hours}:${minutes}`;
};

export function convertToCalendarFormat(input: string): Date {
  let resultDate = new Date(); // default to current date

  // Check if the input is time-only (e.g., "22:00")
  if (input.includes(":")) {
      const [hours, minutes] = input.split(":").map(Number);
      resultDate.setHours(hours, minutes, 0, 0); // set time on the current date
  }
  // Check if the input is a full date (e.g., "2024-10-18")
  else if (input.match(/^\d{4}-\d{2}-\d{2}$/)) {
      resultDate = new Date(input); // create date from the input string
  }

  return resultDate;
}

export function formatDateTwo(inputDate: string): string {
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  
  const date = new Date(inputDate);  // Create a Date object from the input string
  const day = date.getDate();        // Get the day of the month
  const month = months[date.getMonth()];  // Get the month (0-11, so we use it as an index)
  const year = date.getFullYear();   // Get the full year

  return `${month} ${day}, ${year}`;  // Return formatted date string
}